<template>
  <div class="container">
    <AppNavbar
      :placeholder="true"
      :options="options"
      :zIndex="20"
      :title="title"
    >
      <div slot="right">
        <div @click="bindDetail">积分明细</div>
      </div>
    </AppNavbar>
    <van-pull-refresh
      class="point-refresh"
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <div>
        <div class="user-info">
          <img
            class="avatar"
            :src="(userInfo && userInfo.head_img) || defaultAvatar"
            alt=""
          />
          <div class="item-center">
            <div class="text">我的积分</div>
            <div class="number">{{ score }}</div>
          </div>
          <div class="item-right" @click="bindExchange">
            <span class="iconfont icon-ic-gift"></span>
            <span class="text">积分兑好物</span>
          </div>
        </div>
        <!-- 日常任务 -->
        <div class="white-item" v-for="(item, index) in taskData" :key="index">
          <div class="task-title">{{ item.category }}</div>
          <div class="task-list">
            <div
              class="task-item"
              v-for="(item1, index1) in item.list"
              :key="index1"
            >
              <img class="task-icon" :src="item1.icon" />
              <div class="task-center">
                <div class="text">{{ item1.name }}</div>
                <div class="desc">
                  每次<span class="task-red">加{{ item1.reward_num }}积分</span
                  >，{{ taskTypeObj[item1.limit_type] }}最多完成{{
                    item1.limit_num
                  }}次
                </div>
              </div>
              <div class="task-right">
                <div
                  class="status-1"
                  v-if="item1.finish_all || item1.finish_num >= item1.limit_num"
                  >已完成</div
                >
                <div class="status-2" v-else>
                  <div class="line">
                    <div
                      class="cur"
                      :style="{
                        width: computePercent(item1.finish_num, item1.limit_num)
                      }"
                    ></div>
                  </div>
                  <div class="schedule">
                    <span class="cur-schedule">{{ item1.finish_num }}</span
                    ><span>/</span><span>{{ item1.limit_num }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {
      defaultAvatar: 'https://cdnvue.gymcity.com.cn/uploads/pub-red-logo',
      title: '积分中心',
      options: {
        color: '#fff',
        barBackgroundColor: 'transparent'
      },
      taskTypeObj: {
        1: '每天',
        2: '每月',
        3: ''
      },
      score: 0, //积分
      userInfo: null,
      taskData: [],
      loaded: false,
      isLoading: false
    }
  },
  created() {
    this.getScore()
    this.getTaskList()
  },
  mounted() {
    document.addEventListener('scroll', this.bindScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.bindScroll)
  },
  methods: {
    onRefresh() {
      this.getScore(1)
      this.getTaskList()
    },
    computePercent(cur, total) {
      return (cur / total || 0) * 100 + '%'
    },
    //去兑换奖品
    bindExchange() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/integral/index'
        )
      }
    },
    getScore(refresh = 0) {
      let params = {
        refresh
      }
      this.$http
        .getBaseApp('member/info/myWmPoints', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.score = res.data || 0
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    },
    getTaskList() {
      this.$http
        .getBaseApp('member/task.index/index', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.taskData = res.data.task || []
            this.userInfo = res.data.user || null
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    bindScroll(e) {
      let scrollTop = e.target.documentElement.scrollTop
      if (scrollTop <= 20) {
        this.options = {
          barBackgroundColor: 'transparent',
          color: '#fff'
        }
      } else {
        this.options = {
          barBackgroundColor: '#fff'
        }
      }
    },
    //跳转到积分明细
    bindDetail() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/user/point/detail'
        )
      }
    }
  }
}
</script>
<style lang="scss">
.point-refresh {
  .van-pull-refresh__head {
    color: #fff;
  }
  .van-loading {
    color: #fff;
  }
  .van-loading__text {
    color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.container {
  overflow: hidden;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/beebfdec8b631ceebf70c93f5ac9ec52.png');
  background-color: #f9f9f9;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100%;
  min-height: 100vh;
  padding: 0px 20px;
  box-sizing: border-box;
  .user-info {
    display: flex;
    align-items: center;
    margin-top: 22px;
    margin-bottom: 22px;
    .avatar {
      width: 48px;
      height: 48px;
      object-fit: cover;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 12px;
    }
    .item-center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 12px;
      .text {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
      }
      .number {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 42px;
        font-size: 36px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #ffffff;
        line-height: 42px;
      }
    }
    .item-right {
      padding: 0px 10px;
      height: 25px;
      background-color: rgba(52, 0, 57, 0.2);
      border-radius: 13px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      display: flex;
      align-items: center;
      .iconfont {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
  .white-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
  .task-title {
    margin-bottom: 27px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }
  .task-list {
    .task-item {
      display: flex;
      align-items: center;
      margin-bottom: 38px;
      .task-icon {
        width: 32px;
        height: 32px;
        object-fit: contain;
        margin-right: 10px;
      }
      .task-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 2px;
        .text {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
          margin-bottom: 4px;
        }
        .desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.5);
          line-height: 18px;
        }
        .task-red {
          color: rgb(233, 115, 115);
        }
      }
      .task-right {
        .status-1 {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.3);
          line-height: 20px;
        }
        .status-2 {
          display: flex;
          align-items: center;
          .line {
            width: 40px;
            height: 4px;
            background: rgba(98, 54, 255, 0.1);
            border-radius: 2px;
            margin-right: 10px;
            overflow: hidden;
            .cur {
              width: 50%;
              height: 100%;
              border-radius: 2px;
              background: #6b24ff;
            }
          }
          .schedule {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.3);
            line-height: 17px;
          }
          .cur-schedule {
            color: rgba(98, 54, 255, 1);
          }
        }
      }
    }
    .task-item:last-child {
      margin-bottom: 0px;
    }
  }
  .daily-task {
  }
}
.v-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
